<app-card-header [header]="header"></app-card-header>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12 col-xl-12 col-sm-12 w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <div class="row">
                <div class="col-lg col-md text-right" style="align-self: center;">
                    <button mat-flat-button color="primary" class="btnSize" [routerLink]="['/formrs009/novo',0]"
                        matTooltip="Novo Registro" skipLocationChange>
                        <i class="fa fa-plus fa-1x btnIcon"></i>
                        Novo
                    </button>
                    <button mat-flat-button color="primary" (click)="showFilter()" class="btnSize"
                        matTooltip="Filtro Detalhado">
                        <i class="fa fa-filter fa-1x btnIcon"></i>
                        Filtro
                    </button>
                    <button mat-flat-button color="primary" (click)="makeSync()" class="btnSize"
                        matTooltip="Sincronizar">
                        <i class="fa fa-refresh fa-1x btnIcon"></i>
                        Sincronizar
                    </button>
                </div>
            </div>
            <br>

            <div class="table-responsive table-height " *ngIf="areaSelect.includes('Pré-Básica')">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">


                    <ng-container matColumnDef="CreatedAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at"
                            class="InputLabelHeaderColor formatField"> Criado em
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_at | date: 'dd/MM/yyyy
                            HH:mm'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Safra">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="safra_basica"
                            class="InputLabelHeaderColor formatField"> Safra
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.safra_basica}} </td>
                    </ng-container>

                    <ng-container matColumnDef="SiteRecebimento">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="site_recebimento"
                            class="InputLabelHeaderColor formatField"> Site Recebimento</th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.site_recebimento}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Cerar">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="cerar_basica"
                            class="InputLabelHeaderColor formatField"> Cerar
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.cerar_basica}} </td>
                    </ng-container>

                    <ng-container matColumnDef="ContratoJuridico">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="contrato_juridico"
                            class="InputLabelHeaderColor formatField"> Contrato Jurídico </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.contrato_juridico}} </td>
                    </ng-container>


                    <ng-container matColumnDef="NumeroCampo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="numero_campo"
                            class="InputLabelHeaderColor formatField"> Campo (Básica) </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.numero_campo}} </td>
                    </ng-container>

                   
                    <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="is_incomplete"
                            class="InputLabelHeaderColor formatField">
                            Status </th>
                        <td mat-cell *matCellDef="let row"
                            [style.color]="row.is_incomplete || row.offline ? 'red' : 'green'" class="formatField">
                            <span *ngIf="!row.offline">
                                {{row.is_incomplete ? 'Incompleto' : 'Completo'}}
                            </span>
                            <span *ngIf="row.offline">
                                Offline
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="InputLabelHeaderColor formatField">
                            Ações
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <div>
                                <span *ngIf="row.offline">
                                    <button mat-flat-button color="warn" class="mr-1 mt-2 btnSize"
                                        matTooltip="Registro Offline" [routerLink]="[row.id,'editar',1]"
                                        skipLocationChange>
                                        <i class="fa fa-edit fa-1x btnIcon"></i>
                                        Editar
                                    </button>
                                </span>
                                <span *ngIf="!row.offline">
                                    <button mat-flat-button color="primary" class="mr-1 mt-2 btnSize"
                                        matTooltip="Editar Registro" [routerLink]="[row.id,'editar',1]"
                                        skipLocationChange>
                                        <i class="fa fa-edit fa-1x btnIcon"></i>
                                        Editar
                                    </button>
                                </span>
                                <button *ngIf="permissionDelete" mat-flat-button color="warn" class="mr-1 mt-2 btnSize"
                                    matTooltip="Excluír Registro" (click)="delete(row.id)" skipLocationChange>
                                    <i class="fa fa-delete fa-1x btnIcon"></i>
                                    Excluír
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" colspan="100%"><i
                                class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum registro
                            encontrado</td>
                    </tr>
                </table>
                <div class="flipped">
                    <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
                </div>


            </div>

            <div class="table-responsive table-height" *ngIf="!areaSelect.includes('Pré-Básica')">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">


                    <ng-container matColumnDef="CreatedAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at"
                            class="InputLabelHeaderColor formatField"> Criado em
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_at | date: 'dd/MM/yyyy
                            HH:mm'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CreatedBy">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_by"
                            class="InputLabelHeaderColor formatField"> Criado por
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_by}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Safra">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="safra"
                            class="InputLabelHeaderColor formatField"> Safra
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.safra}} </td>
                    </ng-container>

                    <ng-container matColumnDef="SiteRecebimento">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="site_recebimento"
                            class="InputLabelHeaderColor formatField"> Site Recebimento</th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.site_recebimento}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Cerar">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="cerar"
                            class="InputLabelHeaderColor formatField"> Cerar
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.cerar}} </td>
                    </ng-container>

                    <ng-container matColumnDef="ContratoJuridico">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="contrato_juridico"
                            class="InputLabelHeaderColor formatField"> Contrato Jurídico </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.contrato_juridico}} </td>
                    </ng-container>


                    <ng-container matColumnDef="NumeroCampo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="numero_campo"
                            class="InputLabelHeaderColor formatField"> Campo (Básica) </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.numero_campo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Produto">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="produto"
                            class="InputLabelHeaderColor formatField">
                            Produto </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.produto}} </td>
                    </ng-container>

                    <ng-container matColumnDef="RespValidacao">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="resp_validacao"
                            class="InputLabelHeaderColor formatField">
                            Responsável Validação </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.resp_validacao}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="is_incomplete"
                            class="InputLabelHeaderColor formatField">
                            Status </th>
                        <td mat-cell *matCellDef="let row"
                            [style.color]="row.is_incomplete || row.offline ? 'red' : 'green'" class="formatField">
                            <span *ngIf="!row.offline">
                                {{row.is_incomplete ? 'Incompleto' : 'Completo'}}
                            </span>
                            <span *ngIf="row.offline">
                                Offline
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="InputLabelHeaderColor formatField">
                            Ações
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <div>
                                <span *ngIf="row.offline">
                                    <button mat-flat-button color="warn" class="mr-1 mt-2 btnSize"
                                        matTooltip="Registro Offline" [routerLink]="[row.id,'editar',1]"
                                        skipLocationChange>
                                        <i class="fa fa-edit fa-1x btnIcon"></i>
                                        Editar
                                    </button>
                                </span>
                                <span *ngIf="!row.offline">
                                    <button mat-flat-button color="primary" class="mr-1 mt-2 btnSize"
                                        matTooltip="Editar Registro" [routerLink]="[row.id,'editar',1]"
                                        skipLocationChange>
                                        <i class="fa fa-edit fa-1x btnIcon"></i>
                                        Editar
                                    </button>
                                </span>
                                <button *ngIf="permissionDelete" mat-flat-button color="warn" class="mr-1 mt-2 btnSize"
                                    matTooltip="Excluír Registro" (click)="delete(row.id)" skipLocationChange>
                                    <i class="fa fa-delete fa-1x btnIcon"></i>
                                    Excluír
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" colspan="100%"><i
                                class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum registro
                            encontrado</td>
                    </tr>
                </table>
                <div class="flipped">
                    <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
                </div>
            </div>
        </mat-card>
    </div>
</div>

<app-filter-detail>
    <app-form-rs009-filter (filter)="getFilter($event)"></app-form-rs009-filter>
</app-filter-detail>